// @ts-nocheck
import React, { useContext } from 'react';
import classNames from 'classnames';
import TabContext from '../TabContext';
import styles from '../style.module.css';

function Tab(props: any) {
  const { children, index, to, className, containerClassName, renderTab } =
    props;

  const {
    idPrefix,
    activeTab,
    assignRefToTab,
    handleTabClick,
    handleTabKeyDown,
  } = useContext(TabContext);

  function handleClick(event: React.MouseEvent) {
    event.preventDefault();

    handleTabClick(index);
  }

  function handleKeyDown(event: React.MouseEvent) {
    handleTabKeyDown(event, index);
  }

  const tabProps = {
    ref: assignRefToTab,
    className: classNames(styles.tabLink, className),
    href: to,
    role: 'tab',
    id: `${idPrefix}-tab-${index}`,
    tabIndex: activeTab === index ? undefined : '-1',
    'aria-selected': activeTab === index ? 'true' : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    children,
  };

  return (
    <li
      className={classNames(styles.tabItem, containerClassName)}
      role="presentation"
    >
      {renderTab ? (
        renderTab(tabProps)
      ) : (
        <a className="contact-person-focus" {...tabProps} />
      )}
    </li>
  );
}

export default Tab;
